export enum ConstantValues {
  EMPTY_STRING = "",
  YES = "Yes",
  NO = "No",
  CHAT = "Chat",
  TEMPORARY_CHAT = "TemporaryChat",
  SORTING_OPTIONS_CACHE_KEY = "sorting_options",
  FILTER_OPTIONS_CACHE_KEY = "filter_options",
  PERSONAL_WORKSPACE = "Personal Workspace",
  ALL_WORKSPACES = "All Workspaces",
  OTHER_USECASE_NAME = "Other - include in description below",
  DRAFT_MESSAGE = "draftMessage",
  DRAFT_MESSAGE_CONVERSATION_ID = "draftMessageConversationId",
  DRAFT_MESSAGE_WORKSPACE_ID = "draftMessageWorkspaceId",
  SESSION_TIMESTAMP = "sessionTimestamp",
  MY_CHATS_FILTER_WORKSPACE_ID = "myChatsFilterWorkspaceId",
  MY_CHATS_FILTER_FAVORITED = "myChatsFilterFavorited",
  MY_CHATS_FILTER_ASCENDING = "myChatsFilterAscending",
  MY_CHATS_FILTER_SORT_FIELD = "myChatsFilterSortField",
  AI_METRICS_FILTERS_ADO = "aiMetricsFilters:ado",
}

export const ALLOWED_FILE_EXTENSIONS: string[] = [
  "XLSX",
  "JSON",
  "EPUB",
  "RTF",
  "ODT",
  "HTML",
  "TXT",
  "CSV",
  "DOCX",
  "PDF",
  "JPEG",
  "PNG",
  "JPG",
  "GIF",
  "WEBP",
  "MD",
];

export const Constants = {
  NEXT_PUBLIC_CLIENT_URL: "http://localhost:3000/",
  MEMBERS_GROUP_NAME_KEY: "user",
  MEMBERS_GROUP_NAME_VALUE: "user",
  ADMINS_GROUP_NAME_KEY: "admin",
  ADMINS_GROUP_NAME_VALUE: "admin",

  PLATFORM_ADMINS_GROUP_NAME_KEY: "platformAdmin",
  PLATFORM_ADMINS_GROUP_NAME_VALUE: "platformAdmin",

  DECOODA_USERS_GROUP_NAME_KEY: "user", //"decoodaUser",
  DECOODA_USERS_GROUP_NAME_VALUE: "user", //"decoodaUser",
  DECOODA_ADMINS_GROUP_NAME_KEY: "decoodaAdmin",
  DECOODA_ADMINS_GROUP_NAME_VALUE: "decoodaAdmin",

  AI_METRICS_USERS_GROUP_NAME_KEY: "aiMetricsUser",
  AI_METRICS_USERS_GROUP_NAME_VALUE: "aiMetricsUser",
  AI_METRICS_ADMINS_GROUP_NAME_KEY: "aiMetricsAdmin",
  AI_METRICS_ADMINS_GROUP_NAME_VALUE: "aiMetricsAdmin",

  DIAGNOSTICS_USERS_GROUP_NAME_KEY: "user", //"diagnosticsUser",
  DIAGNOSTICS_USERS_GROUP_NAME_VALUE: "user", //"diagnosticsUser",

  DIAGNOSTICS_ADMINS_GROUP_NAME_KEY: "diagnosticsAdmin",
  DIAGNOSTICS_ADMINS_GROUP_NAME_VALUE: "diagnosticsAdmin",

  REPORTING_GROUP_NAME_KEY: "reporting",
  REPORTING_GROUP_NAME_VALUE: "reporting",

  MCP_USER_GROUP_NAME_KEY: "mcpUser",
  MCP_USER_GROUP_NAME_VALUE: "mcpUser",

  PROJECT_IQ_USERS_GROUP_NAME_KEY: "user",
  PROJECT_IQ_USERS_GROUP_NAME_VALUE: "user",
  PROJECT_IQ_ADMINS_GROUP_NAME_KEY: "projectIqAdmin",
  PROJECT_IQ_ADMINS_GROUP_NAME_VALUE: "projectIqAdmin",

  ISSUE_URL_MAILTO:
    "mailto:nhhelpu@northhighland.com?subject=AIMS Support Request",
  ISSUE_URL_MAILTO_ACCESS_ISSUE:
    "mailto:nhhelpu@northhighland.com?subject=AIMS Access Issue",
  ISSUE_URL: "nhhelpu@northhighland.com",
  SUGGEST_PROMPT_MAILTO:
    "mailto:nhaims@northhighland.com?subject=NH%20AIMS%20Prompt%20Suggestion",

  PRIVACY_POLICY_URL: "https://northhighland.com/privacy-policy",
};

export const PAGE_TITLES = {
  AIMS: "NH AIMS",
  NH_DIAGNOSTICS: "NH Diagnostics",
};

export const QueryCacheConfig = {
  STALE_TIME_SHORT: 30_000,
  STALE_TIME_DEFAULT: 5 * 60 * 1000,
  STALE_TIME_LONG: 10 * 60 * 1000,
  CACHE_TIME_DEFAULT: 5 * 60 * 1000,
  CACHE_TIME_LONG: 15 * 60 * 1000,
} as const;
